<ng-container>
  <h6 *ngIf="!isOneOfPaymentsMethodExcluded" role="menuitem" class="navigation__medium--l udex-mb-20">
    {{ 'checkout.digitalNativeCheckout.selectPayment' | cxTranslate }}
  </h6>
  <form [formGroup]="paymentFormGroup">
    <udex-tile
      class="slim-udex-tile d-block udex-mb-20"
      *ngIf="isInvoiceShown"
      [interactive]="true"
      libGroupSkip
      [groupSkipContent]="true"
      [href]="'javascript:void(0)'"
      tabindex="0"
      data-cy="dcp-invoice">
      <udex-radio-button
        *ngIf="!isOneOfPaymentsMethodExcluded"
        class="d-block udex-mx-12"
        data-cy="payment-invoice-radio-btn"
        id="paymentTypeRadioInvoice"
        name="paymentType"
        [attr.text]="'checkout.digitalNativeCheckout.paymentType.invoice.string' | cxTranslate"
        [attr.accessibleName]="'checkout.digitalNativeCheckout.paymentType.invoice.string' | cxTranslate"
        [checked]="paymentTypeControl.value === PaymentTypeCodeReference.ACCOUNT"
        (change)="setPaymentMethodOnEvent($event, PaymentTypeCodeReference.ACCOUNT)"
        (keydown.enter)="setPaymentMethodOnEvent($event, PaymentTypeCodeReference.ACCOUNT)"></udex-radio-button>
      <div
        class="udex-px-24 udex-px-sm-56 udex-pb-20"
        [hidden]="paymentTypeControl.value != PaymentTypeCodeReference.ACCOUNT">
        <div *ngIf="isOneOfPaymentsMethodExcluded" role="heading" class="heading__regular--xxs udex-mb-20">
          {{ 'checkout.digitalNativeCheckout.paymentType.invoice.string' | cxTranslate }}
        </div>
        <dcp-payment-method-invoice [invoiceContacts]="b2bUnitsContacts" [invoiceAddresses]="invoiceAddresses">
        </dcp-payment-method-invoice>
      </div>
    </udex-tile>
    <udex-tile
      class="slim-udex-tile d-block udex-mb-32"
      *ngIf="isCreditCardShown"
      [interactive]="true"
      libGroupSkip
      [groupSkipContent]="true"
      [href]="'javascript:void(0)'"
      tabindex="0"
      data-cy="dcp-credit-cart">
      <udex-radio-button
        class="d-block udex-mx-12"
        *ngIf="!isOneOfPaymentsMethodExcluded"
        data-cy="payment-credit-card-radio-btn"
        id="paymentTypeRadioCC"
        name="paymentType"
        [attr.text]="'checkout.digitalNativeCheckout.paymentType.cc.string' | cxTranslate"
        [attr.accessibleName]="'checkout.digitalNativeCheckout.paymentType.cc.string' | cxTranslate"
        [checked]="paymentTypeControl.value === PaymentTypeCodeReference.CARD"
        (change)="setPaymentMethodOnEvent($event, PaymentTypeCodeReference.CARD)"
        (keydown.enter)="setPaymentMethodOnEvent($event, PaymentTypeCodeReference.CARD)"></udex-radio-button>
      <div
        class="udex-px-24 udex-px-sm-56 udex-pb-20"
        [hidden]="paymentTypeControl.value != PaymentTypeCodeReference.CARD">
        <div *ngIf="isOneOfPaymentsMethodExcluded" role="heading" class="heading__regular--xxs udex-mb-20">
          {{ 'checkout.digitalNativeCheckout.paymentType.cc.string' | cxTranslate }}
        </div>
        <dcp-payment-method-creditcard
          [hidden]="paymentTypeControl.value != PaymentTypeCodeReference.CARD"
          [invoiceContacts]="b2bUnitsContacts"
          [invoiceAddresses]="invoiceAddresses">
        </dcp-payment-method-creditcard>
      </div>
    </udex-tile>
  </form>
</ng-container>
